export enum LocationInfo {
  Gnr = 'Gnr',
  Bnr = 'Bnr'
}
